module.exports = __webpack_public_path__ + "img/Metal Pososity.65108055.png";